<template>
    <div>
        <data-grid
            url="roles"
            :columns="columns"
            :title="title"
            :actions="actions"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            ref="grid"
        ></data-grid>
        <v-dialog v-model="updateRoleDialog" max-width="500">
            <v-card class="pa-2">
                <v-card-title class="headline">Role</v-card-title>
                <v-card-actions>
                    <v-layout column>
                        <v-text-field
                            class="mb-2"
                            label="Name"
                            v-model="role.name"
                        ></v-text-field>

                        <div
                            style="border: 1px solid #47a44b; border-radius: 10px;"
                            class="pa-3 mb-3"
                        >
                            <div class="font-weight-medium mb-2">
                                Users ({{ role.users }})
                            </div>
                            <div class="">{{ role.userNames }}</div>
                        </div>
                        <!-- <v-select
                            class="mb-3"
                            hide-details
                            multiple
                            label="Permissions"
                            chips
                            v-model="role.claims"
                            :items="pages"
                        ></v-select> -->

                        <v-autocomplete
                            class="mb-3"
                            hide-details
                            label="Pages"
                            placeholder="Start typing..."
                            hide-no-data
                            ref="bus"
                            chips
                            multiple
                            v-model="role.claims"
                            :items="pages"
                            :search-input.sync="loadPagesSearch"
                        ></v-autocomplete>

                        <v-select
                            class="mb-5"
                            hide-details
                            multiple
                            label="Categories"
                            chips
                            v-model="role.categories"
                            :items="categories.map((c) => c.description)"
                        ></v-select>

                        <div class="text-xs-right">
                            <v-spacer></v-spacer>
                            <v-btn
                                color="default"
                                dark
                                @click="updateRoleDialog = false"
                                >Cancel</v-btn
                            >
                            <v-btn
                                :loading="processing"
                                color="success"
                                @click="saveRole"
                            >
                                save
                            </v-btn>
                        </div></v-layout
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import paths from "../../router/paths";

export default {
    data: () => ({
        title: "Roles",
        pages: [],
        categories: [],
        actions: [],
        loadPagesSearch: null,
        pagesAll: [],

        columns: [
            {
                sortable: true,
                label: "Name",
                field: "name",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Users",
                field: "users",
                type: "number",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "User Names",
                field: "userNames",
                type: "number",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
        ],

        role: {
            isUpdating: false,
            name: "",
            id: "",
            claims: [],
            categories: [],
        },
        updateRoleDialog: false,
        processing: false,
    }),
    watch: {
        loadPagesSearch(value) {
            if (!value) {
                this.pages = this.pagesAll;

                return;
            }
            if (!this.pagesAll.length) return;

            this.pages = this.pagesAll.filter((b) =>
                b.toUpperCase().startsWith(value.toUpperCase()),
            );
        },
    },
    created() {
        this.loadPages();
        this.loadCategories();

        this.actions.push({
            text: "Add Role",
            action: () => this.onRowClicked(),
        });
    },
    methods: {
        loadPages() {
            this.pagesAll = paths
                .map((p) => p.name)
                .filter(Boolean)
                .sort();

            this.pages = this.pagesAll;
        },
        async loadCategories() {
            const response = await this.$http.get(
                "api/payments/getPaymentCategories",
            );

            this.categories = response;
        },
        async saveRole() {
            this.processing = true;

            const url = this.role.isUpdating
                ? "api/login/UpdateRole"
                : "api/login/CreateRole";

            const claims = this.role.claims.map((claim) => ({
                type: "Page",
                value: claim,
            }));

            this.role.categories.forEach((categoryDescription) => {
                const category = this.categories.find(
                    (c) => c.description == categoryDescription,
                );

                if (
                    claims
                        .filter((c) => c.type == "Category")
                        .some((c) => c.value == category.categoryCode)
                )
                    return;

                claims.push({
                    type: "Category",
                    value: category.categoryCode,
                });
            });

            try {
                await this.$http.post(url, {
                    name: this.role.name,
                    id: this.role.isUpdating ? this.role.id : "",
                    claims: claims,
                });

                this.$refs.grid.load();

                this.resetRole();
            } catch (e) {
            } finally {
                this.processing = false;
                this.updateRoleDialog = false;
            }
        },
        async onRowClicked(role = null) {
            this.resetRole();

            if (role) {
                this.role.name = role.name;
                this.role.id = role.id;
                this.role.users = role.users;
                this.role.userNames = role.userNames;
                this.role.isUpdating = true;

                const claims = await this.$http.get(
                    "api/login/GetRoleClaims?name=" + role.name,
                );

                claims
                    .filter((c) => c.type == "Page")
                    .forEach((claim) => this.role.claims.push(claim.value));
                claims
                    .filter((c) => c.type == "Category")
                    .forEach((claim) => {
                        const category = this.categories.find(
                            (c) => c.categoryCode == claim.value,
                        );

                        this.role.categories.push(category.description);
                    });
            }

            this.updateRoleDialog = true;
        },
        resetRole() {
            this.role.claims.splice(0, this.role.claims.length);
            this.role.categories.splice(0, this.role.categories.length);
            this.role.name = "";
            this.role.isUpdating = false;
        },
    },
};
</script>
<style></style>
